var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view'),_vm._v(" "),_c('app-header'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"page-main"}},[_c('header',{staticClass:"content-header"},[_c('div',{staticClass:"wrapper"},[_c('h1',[_vm._v("Bienvenue")])])]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"widgets"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eed59052","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/dashboard/Dashboard.vue
// module id = 275
// module chunks = 0